/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FredIsRedFeatureAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class FredIsRedFeatureAPI {
		/**
		 * initializeFredIsRedFeature is function that initializes FredIsRed
		 * @param fredIsRedSpec an object that contains FredIsRed spec
		 */
		initializeFredIsRedFeature(){}
		/**
		 * getColor is the main API to a renderer.
		 * it honours an existing sharedPalette but, if the value is not there, augments it.
		 * @param paletteInfo an object that includes a color table, a default index and a Class to be returned with the color
		 *						(where the color expects an RGB object).
		 * @param labelArray -an array of 1 or more labels that make up a tuple (label value) to be coloured  eg: ['Canada'] or ['Canada', '2005']
		 * @param {DataItemAPI} dataItem - data item type
		 * @returns an instance of the ColorClass.
		 */
		getColor() {}

		/**
		 * setUserColorMap - sets user color map
		 * @param colorMap - object representing user color map
		 */
		setUserColorMap() {}

		/**
		 * getUserColorMap - gets user color map (used for testing primarily)
		 */
		getUserColorMap() {}

		/**
		 * registerKeyProvider is function that registeres key provider
		 * @param keyProvider an object that includes key provider to be registered
		 */
		registerKeyProvider() {}
	}
	return FredIsRedFeatureAPI;
});
